export const EVENTS_SCHEMA_VERSION = "0.52.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.25.0";
